module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[26]147.05e0d6e.woff2";